module.exports = __webpack_public_path__ + "img/icona_territorio.0d844a17.png";